import styled from 'styled-components';

export const Chart = styled.div`
  margin-top: 16px;
`;
